import { render, staticRenderFns } from "./start.view.vue?vue&type=template&id=c35439c6&scoped=true"
import script from "./start.view.vue?vue&type=script&lang=js"
export * from "./start.view.vue?vue&type=script&lang=js"
import style0 from "./start.view.vue?vue&type=style&index=0&id=c35439c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35439c6",
  null
  
)

export default component.exports